import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@api/api.service';
import { ModalService } from '@shared/modal/modal.service';
import { StatusCodes } from '@shared/types/status-codes';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rav-authenticator2fa',
  templateUrl: './authenticator2fa.component.html',
  styleUrls: ['./authenticator2fa.component.scss']
})
export class Authenticator2faComponent implements OnInit, OnDestroy {
  @Input() redirectOnSuccess = true;
  @Output() close2faSetUp = new EventEmitter<any>();

  subscriptionList: Subscription = new Subscription();
  modalData: any = null;
  code: number = null;
  errorMessage = null;

  constructor(
    private modal: ModalService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.subscriptionList.add(
      this.modal.open.subscribe((data) => {
        if (data && data['modalId'] === 'authenticator-2fa') {
          this.modalData = data['modalData'];
        }
      })
    );

    this.subscriptionList.add(
      this.modal.close.subscribe((data) => {
        if (data && data['modalId'] === 'authenticator-2fa') {
          if (this.redirectOnSuccess) {
            this.router.navigated = false;
            this.router.navigate([this.router.url]);
          }
          this.close2faSetUp.emit(data);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  closeModal(): void {
    this.modalData = null;
    this.errorMessage = null;
    this.modal.close.next({ modalId: 'authenticator-2fa', codeVerified: false });
  }

  /**
   * Verify the Authentication app code.
   */
  verifyCode(): void {
    this.api.users.me.twoFactor.patch(this.code.toString()).subscribe(
      (response) => {
        if (response.status === StatusCodes.OK) {
          this.displaySuccessMessage('Two factor authentication setup successful');
          this.modal.close.next({ modalId: 'authenticator-2fa', codeVerified: true });
        }
      },
      (error) => {
        this.errorMessage = error.error.message;
      }
    );
  }

  /**
   * display the error message
   *
   * @param message the error message
   */
  displaySuccessMessage(message): void {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: ['success-bg', 'bold', 'light-color']
    });
  }
}
